import * as React from "react";
import { Tooltip, message } from "antd";
import { EUrl } from "utils/enum/url";
// 浏览器复制
import { CopyToClipboard } from "react-copy-to-clipboard";

// 订单列表中的账号字段

const showMessage = () => {
  message.config({
    duration: 1,
    maxCount: 1
  });
  message.info("复制成功");
};

// 判断显示复制图标
const showCopy = (taoAccount, containerBody) => {
  // 淘宝账号有值时显示旺旺图标
  if (taoAccount) {
    const _getContainer = () => {
      return getContainer(containerBody);
    };
    return (
      <CopyToClipboard text={taoAccount}>
        <Tooltip title="点击复制到剪切板" getTooltipContainer={_getContainer}>
          <a
            onClick={showMessage}
            style={{ padding: "0 8px", display: "inline-block" }}
          >
            <i className="list-link action-user action-fuzhi" />
          </a>
        </Tooltip>
      </CopyToClipboard>
    );
  }
  return [];
};

// 判断显示旺旺图标
const showWangwang = (taoAccount, containerBody) => {
  // 淘宝账号有值时显示旺旺图标
  if (taoAccount) {
    const _getContainer = () => {
      return getContainer(containerBody);
    };
    const url = EUrl.wangwang.replace("@var@", taoAccount);
    return (
      <Tooltip
        placement="top"
        title="跳转到旺旺"
        getTooltipContainer={_getContainer}
      >
        <a href={url} target="_blank">
          <i
            className="action-user action-wangwang"
            style={{ cursor: "pointer", color: "#2b9fbd" }}
          />
        </a>
      </Tooltip>
    );
  }
  return [];
};

const getContainer = containerBody => {
  if (containerBody) {
    return document.querySelector(containerBody) || document.body;
  } else {
    return document.body;
  }
};

export default (onSearch, containerBody) => {
  // 可实现在页面内搜索
  // const _searchAccount = text => {
  //   return e => {
  //     onSearch(text);
  //   };
  // };

  return {
    render: (text, record) => {
      return (
        <React.Fragment>
          {showCopy(record.account, containerBody)}
          <span style={{ marginRight: 4 }}>
            <a
              className="list-link"
              href={"?account=" + record.account}
              target="_blank"
            //onClick={_searchAccount(record.account)}
            >
              {record.account || "-"}
            </a>
          </span>
          {showWangwang(record.account, containerBody)}
        </React.Fragment>
      );
    }
  };
};
